module.exports = __webpack_public_path__ + "static/media/pinZero.81fde1ff.png";